export const SHIPMENT_EMAILS_TAB = 'SHIPMENT_EMAILS_TAB';

export const DELIVERY_EMAILS_TAB = 'DELIVERY_EMAILS_TAB';

export const TYPE = {
  SHIPMENT: '0',
  DELIVERY: '2',
};
